import React from 'react'
import styled from 'styled-components'
import { Text } from '../../../modules/Dashboard'
import { ClipLoader } from 'react-spinners'

const DeleteModal = ({
	title = 'delete-orders',
	desc = 'delete-confirmation',
	onConfirm,
	onClose,
	isLoading = false,
}) => {
	return (
		<div style={{ width: '100%' }}>
			<MText>
				<Text tid={title} className='font-semibold' />
			</MText>
			<MText>
				<Text tid={desc} />
			</MText>
			<BtnContainer>
				<Btn
					onClick={onConfirm}
					bgColor='#179f44'
					disabled={isLoading}
				>
					{
						isLoading ? (<ClipLoader color='#ffffff' size={14} />) :
							<Text tid={'confirm'} />
					}
				</Btn>

				<Btn
					onClick={onClose}
					bgColor='#871f48'
					disabled={isLoading}
				>
					<Text tid='cancel' />
				</Btn>
			</BtnContainer>
		</div>
	)
}

const MText = styled.div`
	width: 100%;
	text-align: start;
	color: ${(props) => props.theme.color || '#ffffff95'};
	font-size: 1rem;
	padding-bottom: 20px;
`

const BtnContainer = styled.div`
	display: flex;
	justify-content: space-around;
	align-items: center;
	gap: 10px;
`

const Btn = styled.div`
	display: flex;
	justify-content: center;
	align-items: center;
	border-radius: 10px;
	width: 100%;
	height: 48px;
	margin-top: 16px;
	cursor: pointer;
	font-size: 0.85rem;

	background-color: ${(props) => props.bgColor || '#1b1e23'};
	color: ${(props) => props.theme.secondaryBg || 'black'};
	opacity: ${(props) => (props.disabled ? 0.6 : 1)};
	pointer-events: ${(props) => (props.disabled ? 'none' : 'auto')};
	transition: all 0.3s ease;
`

export default DeleteModal
